/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class DevilsCrossRoadGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_BASE_MULTI = "NumbersMult";
    static BITMAP_FONT_NUMBERS_COIN = "NumbersCoin";
    static BITMAP_FONT_NUMBERS_FS_WIN = "NumbersFSWin";
    static BITMAP_FONT_NUMBERS_COIN_GLOW = "NumbersCoinGlow";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "freespinBackground";
    public static REEL_BACKGROUND:string = "ReelBG";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],
        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_BASE_MULTI, "fonts/bitmapfonts/NumbersMult.fnt"),
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_COIN, "fonts/bitmapfonts/NumbersCoin.fnt"),
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_FS_WIN, "fonts/bitmapfonts/NumbersFSWin.fnt"),
                    new BitmapFontAsset(DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_COIN_GLOW, "fonts/bitmapfonts/NumbersCoinGlow.fnt")
                ]
            },
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json")
                ],
                animations : {
                    "fs_reel" : "FS/fs_reel",
                    "coin_highlight": "Coin_HL/coin_hl_",
                    "coin_highlight_r": "Coin_HL_Radial/coin_hl_radial_",
                    "fs_reel_flowfx" : "fs_reel_flow/fs_reel_flowfx_",
                    "fs_reel_flowfx_horizontal" : "fs_reel_flow_horizontal/fs_reel_flowfx_horizontal_"
                }
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/main/mainHigh0.json")
                ]
            },
            {
                name : "reelBlockerShadowJpeg",
                assets : [
                    new TextureAsset("reelBlockerShadowJpeg0", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg0.json"),
                    new TextureAsset("reelBlockerShadowJpeg1", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg1.json"),
                    new TextureAsset("reelBlockerShadowJpeg2", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg2.json"),
                    new TextureAsset("reelBlockerShadowJpeg3", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg3.json")
                ],
                animations : {
                    "reelBlockerShadow" : "ReelBlockerShadow/ReelBlocker_",
                    "shuffleShadow" : "ShuffleShadows/ShuffleShadows_"
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {}
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("L", "spine/L.json"),
                    new SpineAsset("M", "spine/M.json"),
                    new SpineAsset("S", "spine/S.json"),
                    new SpineAsset("W", "spine/W.json"),
                    new SpineAsset("D", "spine/D.json"),
                    new SpineAsset("DBody", "spine/D_body.json"),
                    new SpineAsset("fs_feature", "spine/fs_feature.json"),
                    new SpineAsset("fsMeter", "spine/fs_meter.json"),
                    new SpineAsset("BW1", "spine/bigwin1.json"),
                    new SpineAsset("BW2", "spine/bigwin2.json"),
                    new SpineAsset("BW3", "spine/bigwin3.json"),
                    new SpineAsset("BW4", "spine/bigwin4.json"),
                    new SpineAsset("BW5", "spine/bigwin5.json"),
                    new SpineAsset("bonusIntro", "spine/fs_intro.json"),
                    new SpineAsset("bonusOutro", "spine/fs_outro.json"),
                    new SpineAsset("mainReelFrame", "spine/reel_frame.json"),
                    new SpineAsset("mainReelSmoke", "spine/reel_smoke.json"),
                    new SpineAsset("reelBacklight", "spine/fs_reel_backlight.json"),
                    new SpineAsset("reelGlowHorizontal", "spine/fs_reel_glow_h.json"),
                    new SpineAsset("reelGlowVertical", "spine/fs_reel_glow_v.json"),
                    new SpineAsset("featureMiss", "spine/nowin.json"),
                    new SpineAsset("fsHeartIndicator", "spine/fs_spin_counter.json"),
                    new SpineAsset("fsCandle", "spine/fs_candle.json"),
                    new SpineAsset("wincap","spine/maxwin.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}